import request from '@/plugins/axios-java-formdata'
/**
 * 获取角色权限和是否可开通门店
 * @export getAppAuthInfoServer
 * @param data
 * @returns
 */
export function getAppAuthInfoServer (data) {
  return request({
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.auth.info',
    data
  })
}
